import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useHardFacts } from "@/contexts/classified";
import { useTags } from "@/hooks";
import { useI18n } from "@/shared/hooks";
import { Box } from "@gemini/core";
export const projectHardfactInfoTestId = "cdp-project-hardfact-info";
export const ProjectHardfactInfo = () => {
    // @ts-ignore
    const { title } = useHardFacts();
    const { t } = useI18n();
    const { hasBrokerageFee } = useTags();
    const subtitle = t("new_build.project_listing.tag") +
        (hasBrokerageFee
            ? ""
            : ` · ${t("hardfacts.title.addition.commission_free")}`);
    return (_jsxs(Box, { testId: projectHardfactInfoTestId, display: "flex", flexDirection: "column", gap: "spacing.8", children: [_jsx(Box, { as: "span", typography: "typography.body.16.bold", children: subtitle }), _jsx(Box, { as: "span", "aria-hidden": true, typography: "typography.headline.24.bold", children: title })] }));
};
